export default {
  meta: {
    title: '创建踩点任务',
  },
};
